import React from 'react';

function ViewEvents({ data }) {
  if (!data) {
    return <div className="text-center py-4">No data available</div>;
  }

  // Format date for display
  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Get status badge
  const getStatusBadge = (status) => {
    const statusMap = {
      'upcoming': { class: 'bg-info', label: 'Upcoming' },
      'ongoing': { class: 'bg-success', label: 'Ongoing' },
      'completed': { class: 'bg-secondary', label: 'Completed' },
      'cancelled': { class: 'bg-danger', label: 'Cancelled' }
    };
    const statusInfo = statusMap[status?.toLowerCase()] || statusMap['upcoming'];
    return <span className={`badge ${statusInfo.class}`}>{statusInfo.label}</span>;
  };

  // Fields to display
  const displayFields = [
    { key: 'title', label: 'Event Title' },
    { key: 'description', label: 'Description' },
    { key: 'venue', label: 'Venue' },
    { key: 'start_date', label: 'Start Date' },
    { key: 'end_date', label: 'End Date' },
    { key: 'capacity', label: 'Capacity' },
    { key: 'status', label: 'Status' },
    { key: 'image_url', label: 'Image' },
    { key: 'created_at', label: 'Created At' },
    { key: 'updated_at', label: 'Updated At' },
  ];

  const getValue = (key) => {
    if (key === 'status') {
      return getStatusBadge(data[key]);
    }
    if (key === 'image_url') {
      return data[key] ? (
        <img 
          src={data[key]} // FIXED: Use full URL from backend
          alt="Event" 
          style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover' }}
          className="img-thumbnail"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/placeholder-image.png';
          }}
        />
      ) : 'No Image';
    }
    if (key === 'start_date' || key === 'end_date') {
      return formatDate(data[key]);
    }
    if (key === 'capacity') {
      return data[key] || 'Unlimited';
    }
    return data[key] || 'N/A';
  };

  return (
    <div className="view-event-container">
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <tbody>
            {displayFields.map((field) => (
              <tr key={field.key}>
                <th style={{ width: '40%', backgroundColor: '#f8f9fa' }}>
                  {field.label}
                </th>
                <td>
                  {getValue(field.key)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewEvents;